<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">Import Statement</li>
  </ol>
</nav>

<div class="page-header">
  <div class="row align-items-center">
    <div class="col">
      <h1 class="page-header-title">Import Statement</h1>
    </div>
  </div>
</div>

<div *ngIf="processingError" class="alert alert-danger my-3" role="alert">
  {{ processingError }}
</div>

<!-- State-dependent content -->
<div class="mb-4">
  @if(state === ImportStatementStateEnum.WaitingForStatement) {
    <div class="row">
      <div class="col-12">
        <h2><i class="bi bi-file-earmark-arrow-up-fill"></i> Import a bank/credit card statement or receipt</h2>
        <magieno-drag-and-drop (onFileSystemHandlesDropped)="onFileSystemHandlesDropped($event)" class="d-block"
                              style="min-height: 200px; border: 2px dashed #ccc; padding: 20px; border-radius: 8px; background-color: #f9f9f9;">
          <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100 text-center">
            <i class="bi bi-cloud-arrow-up-fill text-primary" style="font-size: 3rem;"></i>
            <p class="mt-3 mb-0 fs-5">Click or drag and drop a file here.</p>
            <p class="text-muted">Supports <strong><i class="bi bi-filetype-csv"></i>.csv</strong>, <strong><i class="bi bi-filetype-pdf"></i>.pdf</strong>, or <strong>image</strong> files (e.g., .png, .jpg).</p>
          </div>
        </magieno-drag-and-drop>
      </div>
    </div>
  } @else if (state === ImportStatementStateEnum.PreviewingStatement) {
    <div class="row">
      <div class="col-12">
        <h4 class="mb-3">Statement Preview</h4>
        <div class="card">
          <div class="card-body">
            <app-statement-preview [previewData]="previewData"></app-statement-preview>
          </div>
        </div>
        <div class="mt-4 text-center">
          <button class="btn btn-lg btn-primary me-3" (click)="confirmAndProcessStatement()">
            <i class="bi bi-check-circle-fill me-2"></i>Confirm and Process Statement
          </button>
          <button class="btn btn-lg btn-outline-danger" (click)="state = ImportStatementStateEnum.WaitingForStatement; previewData = null; currentFile = null; processingError = null;">
            <i class="bi bi-x-circle me-2"></i>Cancel
          </button>
        </div>
      </div>
    </div>
  } @else if (state === ImportStatementStateEnum.ProcessingStatement) {
    <div class="row justify-content-center text-center py-5">
      <div class="col-auto">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Processing file...</span>
        </div>
        <p class="mt-3 fs-5">Processing file... Please wait.</p>
      </div>
    </div>
  } @else if (state === ImportStatementStateEnum.StatementProcessed) {
    <div class="row justify-content-center text-center py-5">
      <div class="col-auto">
        <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
        <h4 class="mt-3">Statement Processed!</h4>
        <p class="fs-5">Expenses found have been processed.</p>
        <p class="text-muted">(Further steps like review or listing would follow here)</p>
        <button class="btn btn-lg btn-info mt-3" (click)="state = ImportStatementStateEnum.WaitingForStatement; previewData = null; currentFile = null; processingError = null;">
          <i class="bi bi-file-earmark-arrow-up-fill me-2"></i>Import Another Statement
        </button>
      </div>
    </div>
  } @else if (state === ImportStatementStateEnum.ReviewExpensesFound) {
      <div class="row justify-content-center py-5">
          <div class="col-12">
            <h4 class="mt-3 text-center">Review Expenses</h4>
            <app-expense-import-table [expenseOptions]="expenseOptions"></app-expense-import-table>
            <div class="mt-4 text-center">
              <button class="btn btn-lg btn-secondary mt-3" (click)="state = ImportStatementStateEnum.WaitingForStatement; previewData = null; currentFile = null; processingError = null; expenseOptions = [];">
                <i class="bi bi-arrow-left-circle me-2"></i>Start Over
              </button>
              <!-- Add save/confirm button here if needed -->
            </div>
          </div>
      </div>
  }
</div>


<magieno-collapsible-card class="mt-5" [(collapsed)]="debugCollapsed" (collapsedChange)="debugCollapsedChange()">
  <div headerContent>Debug</div>
  <div class="mt-3">
    <h6>Pdf (.pdf) or Image (.png, .jpg, etc..) prompt override</h6>

    <div class="form-group">
      <label>System prompt</label>
      <textarea class="form-control" rows="5" [formControl]="promptProvider.imageExtractionSystemPromptFormControl"></textarea>
    </div>
    <div class="form-group">
      <label>User prompt</label>
      <textarea class="form-control" rows="5" [formControl]="promptProvider.imageExtractionUserPromptFormControl"></textarea>
    </div>
    <div class="form-group mt-3">
      <label>JSON Schema</label>
      <magieno-code-editor [control]="promptProvider.imageExtractionJSONSchemaFormControl"></magieno-code-editor>
    </div>
<!--    <hr>-->
<!--    <h6 class="mt-2">CSV (.csv) prompt override</h6>-->


  </div>
</magieno-collapsible-card>
